import { render, staticRenderFns } from "./EditWmtsMap.vue?vue&type=template&id=2c1227cb&scoped=true"
import script from "./EditWmtsMap.vue?vue&type=script&lang=js"
export * from "./EditWmtsMap.vue?vue&type=script&lang=js"
import style0 from "./EditWmtsMap.vue?vue&type=style&index=0&id=2c1227cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1227cb",
  null
  
)

export default component.exports